exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: blue;\n  z-index: 1000;\n  font-size: 1.2em;\n}\n\n.nav-toggle-link {\n  position: absolute;\n  z-index: 1001;\n  font-size: 1.5em;\n  background: transparent;\n  border: none;\n  padding: 1.5rem 1rem;\n  cursor: pointer;\n  outline: none;\n}\n\n.nav a {\n  color: white;\n  font-size: 1.5rem;\n}\n\n.social-links {\n  position: absolute;\n  bottom:1rem;\n  left:2rem;\n  font-size: 1rem;\n}\n\n.social-links a {\n  margin-right: 1rem;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main